// @flow

import type { OpenedIncomingPayment } from './types';
import type { PaymentOption } from './payment-option';

export function getSafePaymentOptions(incomingPayment: OpenedIncomingPayment): ImmutableArray<PaymentOption> {
  const paymentOptions = incomingPayment['payment_options'];
  if(!paymentOptions)
    throw new Error('Payment Options: no payment options for opened payment');

  return paymentOptions;
}
